import Head from "next/head";

interface IBlogPageSeo {
    title?: string;
    description?: string;
    url?: string;
    canonicalUrl?: string;
    image?: string;
    pathname?: string;
    publishDate?: string;
    heroImageUrl?: string;
    author?: {
        avatar: null | string;
        id: string;
        name: string;
    };
    estimatedReadingTime?: string;
}

function BlogPageSeo({
    url,
    title,
    description,
    canonicalUrl,
    publishDate,
    heroImageUrl,
    author,
    estimatedReadingTime,
}: IBlogPageSeo) {
    return (
        <Head>
            <title>{title}</title>
            <meta name="title" content={title} />
            {description && <meta name="description" content={description} />}

            <meta name="robots" content="index, follow" />
            <meta name="revisit-after" content="15 days" />
            <link rel="canonical" href={canonicalUrl || url} />

            {/* Open Graph / Facebook */}
            <meta property="og:locale" content="en_GB" />
            <meta property="og:type" content="article" />
            <meta property="og:site_name" content="The Gender Index" />
            {title && <meta property="og:title" content={title} />}
            {url && <meta property="og:url" content={url} />}
            {publishDate && <meta property="article:published_time" content={publishDate} />}
            {publishDate && <meta property="article:modified_time" content={publishDate} />}
            {author?.name && <meta name="author" content={author.name} />}
            {heroImageUrl && <meta property="og:image" content={heroImageUrl} />}
            {description && <meta property="og:description" content={description} />}

            {/* Twitter */}
            <meta property="og:site_name" content="The Gender Index" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:creator" content="@TheGenderIndex" />
            <meta name="twitter:site" content="@TheGenderIndex" />
            {url && <meta property="twitter:url" content={url} />}

            {title && <meta property="twitter:title" content={title} />}
            {description && <meta property="twitter:description" content={description} />}
            {heroImageUrl && <meta name="twitter:image" content={heroImageUrl} />}
            {author?.name && <meta name="twitter:label1" content="Written by" />}
            {author?.name && <meta name="twitter:data1" content={author.name} />}
            <meta name="twitter:label2" content="Estimated reading time" />
            <meta name="twitter:data2" content={estimatedReadingTime || "2 minutes"} />
        </Head>
    );
}

export default BlogPageSeo;
